import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";

const faqs = [
  {
    q: "¿Cuánto tarda una web?",
    a: "La mayoría de los proyectos se entregan entre dos y tres semanas desde la firma del acuerdo y la recepción del contenido necesario.",
  },
  {
    q: "¿Necesito tener todo el contenido preparado?",
    a: "No. Si todavía no tienes todo el contenido preparado, podemos ayudarte a estructurarlo. También ofrecemos redacción de páginas web y ghostwriting como servicios complementarios.",
  },
  {
    q: "¿Puedo solicitar cambios después del lanzamiento?",
    a: "Sí. El proyecto incluye cinco pequeñas mejoras durante los primeros 30 días tras el lanzamiento para realizar ajustes o cambios menores. Si más adelante necesitas nuevas funcionalidades o mejoras, siempre podremos seguir trabajando juntos.",
  },
  {
    q: "¿Trabajáis solo con empresas de España?",
    a: "No. Aunque La Michi Agencia está en Barcelona, trabajamos con empresas de cualquier lugar.",
  },
  {
    q: "¿Qué ocurre si necesito algo fuera del paquete?",
    a: "Algunos proyectos requieren funcionalidades específicas o un desarrollo completamente a medida. En esos casos estudiaremos tu proyecto y te diremos con total transparencia si es algo que podemos hacer o si es mejor recomendarte otra solución.",
  },
  {
    q: "¿Ofrecéis acompañamiento después del lanzamiento?",
    a: "Sí. Si tu negocio evoluciona, podemos seguir ayudándote con nuevas páginas, contenido, mejoras y optimizaciones. Cada necesidad se valora de forma individual.",
  },
  {
    q: "¿Cómo empezamos?",
    a: "Solo tienes que rellenar el formulario de contacto y contarnos un poco sobre tu proyecto. Revisaremos la información y, si creemos que somos el estudio adecuado para ayudarte, nos pondremos en contacto contigo para dar el siguiente paso.",
  },
];

function FaqItem({ item, i, open, onToggle }) {
  return (
    <div data-testid={`faq-item-${i + 1}`} className="border-b border-[color:var(--ink-10)]">
      <button onClick={onToggle} className="w-full flex items-baseline justify-between gap-6 py-8 lg:py-10 text-left">
        <div className="flex items-baseline gap-6">
          <span className="font-sans text-[12px] tracking-[0.22em] uppercase text-[color:var(--ink-60)]">
            {String(i + 1).padStart(2, "0")}
          </span>
          <h3 className="font-display text-2xl sm:text-3xl lg:text-4xl leading-[1.15] tighter pb-1">{item.q}</h3>
        </div>
        <span className={`inline-flex items-center justify-center w-10 h-10 rounded-full border border-[color:var(--ink-10)] shrink-0 transition-transform duration-500 ${open ? "rotate-45 bg-[#111111] text-[#FAF8F5]" : ""}`}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M6 1v10M1 6h10" stroke="currentColor" strokeWidth="1.4" /></svg>
        </span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
            className="overflow-hidden"
          >
            <div className="pb-10 lg:pb-12 pl-10 lg:pl-16 pr-8 max-w-3xl font-sans text-base lg:text-lg leading-relaxed text-[color:var(--ink)]/80">
              {item.a}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="relative py-16 lg:py-24">
      <div className="max-w-[95%] mx-auto grid grid-cols-12 gap-6 lg:gap-16">
        <div className="col-span-12 lg:col-span-4">
          <div className="font-sans text-[11px] tracking-[0.24em] uppercase text-[color:var(--ink-60)] mb-6">
            — Preguntas frecuentes · Índice 006
          </div>
          <h2 className="font-display text-5xl lg:text-6xl leading-[1.02] tightest pb-2">
            Dudas <span className="font-italic-display">frecuentes.</span>
          </h2>
          <p className="mt-6 font-sans text-sm leading-relaxed text-[color:var(--ink-60)] max-w-xs">
            ¿No encuentras la tuya? Escríbenos a{" "}
            <a href="mailto:hello@lamichiagencia.com" className="link-underline text-[color:var(--ink)]">
              hello@lamichiagencia.com
            </a>{" "}
            y te respondemos en menos de un día laborable.
          </p>
        </div>

        <div className="col-span-12 lg:col-span-8 border-t border-[color:var(--ink-10)]">
          {faqs.map((f, i) => (
            <FaqItem key={i} item={f} i={i} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />
          ))}
        </div>
      </div>
    </section>
  );
}
